import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useEffect, useState } from "react";

import { DashDateTimeContainer } from "./DateTime.styled";

// Add timezone support to dayjs
dayjs.extend(utc);
dayjs.extend(timezone);

const DashDateTime = () => {
  const userTz = dayjs.tz.guess();

  const [currentDateTime, setCurrentDateTime] = useState(dayjs().tz(userTz));

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(dayjs().tz(userTz));
    }, 1000);
    return () => clearInterval(timer);
  }, [userTz]);

  const formatDate = (date: dayjs.Dayjs) =>
    date.format("ddd DD MMMM").toUpperCase();

  const formatTime = (date: dayjs.Dayjs) =>
    date.format("HH:mm:ss A") + " " + date.tz().format("LT");

  return (
    <DashDateTimeContainer className="dateTimeDisplay">
      <div className="date">{formatDate(currentDateTime)}</div>
      <div className="time">{formatTime(currentDateTime)}</div>
    </DashDateTimeContainer>
  );
};

export default DashDateTime;
